export default __webpack_public_path__ + "static/media/ace_proj.d9c8d1ec.png";